import { createAction, handleActions } from "redux-actions";
// - Actions
export const searchColorRequest = createAction("COLOR_LIST_SEARCH_REQUEST");
export const searchColorSuccess = createAction("COLOR_LIST_SEARCH_SUCCESS");

export const getColorByIdRequest = createAction("GET_COLOR_BY_ID_SEARCH_REQUEST");
export const getColorByIdSuccess = createAction("GET_COLOR_BY_ID_SEARCH_SUCCESS");

export const updateColorRequest = createAction("UPDATE_COLOR_REQUEST");
export const updateColorSuccess = createAction("UPDATE_COLOR_SUCCESS");

export const deleteColorRequest = createAction("DELETE_COLOR_REQUEST");

export const failure = createAction("COLOR_ACTION_FAILURE");

// - Initial State
export const initialState = {
  colors: [],
  pagination: {
    pages: 1,
    page: 20,
    total: 0
  },
  loading: false,
  color: null,
  error: null
};

// - Reducers
const reducer = handleActions(
  {
    [searchColorRequest]: state => ({
      ...state,
      loading: true
    }),
    [searchColorSuccess]: (state, { payload: { colors, pagination } }) => ({
      ...state,
      colors: colors,
      pagination: pagination,
      loading: false
    }),

    [getColorByIdSuccess]: (state, { payload: { color } }) => ({
      ...state,
      color: color,
    }),

    [failure]: (state, action) => ({
      ...state,
      loading: false,
      error: action.error
    })
  },
  initialState
);

export default reducer;
